import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.css'
import { CheckIcon } from '../../assets/svgs/icons'

export const StatusBadge = ({ status, onRetry, onCancel, onClick }) => {
  const { t } = useTranslation()

  const STATUS_CONFIG = {
    pending: {
      label: t('status_badge.pending'),
      statusClass: styles.pending,
      icon: <span className={styles.pulseDot} />,
    },
    success: {
      label: t('status_badge.success'),
      statusClass: styles.success,
      icon: <CheckIcon color='#3cbc00' size={16}/>,
    },
    error: {
      label: t('status_badge.error'),
      statusClass: styles.error,
      icon: <span className={styles.errorIcon}>X</span>,
    },
  }

  const config = STATUS_CONFIG[status] || STATUS_CONFIG.pending

  return (
    <div className={styles.container} onClick={onClick}>
      <div className={`${styles.badge} ${config.statusClass}`}>
        {config.icon}
        <span className={styles.label}>{config.label}</span>
      </div>

      {status === 'error' && (
        <div className={styles.actions}>
          <button type="button" className={styles.primaryButton} onClick={onRetry}>
            {t('status_badge.retry_button')}
          </button>
          <button type="button" className={styles.secondaryButton} onClick={onCancel}>
            {t('status_badge.cancel_button')}
          </button>
        </div>
      )}
    </div>
  )
}

StatusBadge.propTypes = {
  status: PropTypes.oneOf(['pending', 'success', 'error']),
  onRetry: PropTypes.func,
  onCancel: PropTypes.func,
}

StatusBadge.defaultProps = {
  status: 'pending',
}

export default StatusBadge
